import NotFoundBanner from "../../components/feedback/NotFoundBanner/NotFoundBanner";
import BaseLayout from "../../components/layout/BaseLayout/BaseLayout";

const NotFoundPage = (): JSX.Element => {
    return (
        <BaseLayout>
            <NotFoundBanner />
        </BaseLayout>
    );
};

export default NotFoundPage;
